import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    createvoucher,
    getvouchertypes,
    listaccounts,
    getactivebankaccounts,
    viewvoucher,
    memberlist,
} from "../../../../services/admin";
import { toast } from "react-toastify";
import Select from "react-select";

export default function AddVoucher() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [voucherTypes, setVoucherTypes] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        id: 0,
        voucher_type_id: "",
        voucher_date: new Date().toISOString().split("T")[0],
        total_amount: 0,
        payment_mode: "Cash",
        bank_account_id: null,
        cheque_number: "",
        cheque_date: "",
        narration: "",
        status: "Draft",
        ledger_entries: [
            { account_id: "", debit_amount: 0, credit_amount: 0, narration: "" },
            { account_id: "", debit_amount: 0, credit_amount: 0, narration: "" },
        ],
    });

    useEffect(() => {
        // Fetch voucher types
        getvouchertypes().then((res) => {
            if (res.status === true) {
                const options = res.data.map((vt) => ({
                    value: vt.id,
                    label: vt.type_name,
                    code: vt.type_code,
                }));
                setVoucherTypes(options);
            }
        });

        // Fetch all accounts
        fetchAllAccounts();

        // Fetch bank accounts
        getactivebankaccounts().then((res) => {
            if (res.status === true) {
                const options = res.data.map((bank) => ({
                    value: bank.id,
                    label: `${bank.bank_name} - ${bank.account_number}`,
                }));
                setBankAccounts(options);
            }
        });

        // Fetch members for narration appending
        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        memberlist(temp).then((res) => {
            if (res.status === true) {
                const options = res.data.map((m) => ({
                    value: m.id || m.member_id || m.member_no,
                    label: `${m.member_name} - ${m.phone_no || ''}`,
                }));
                setMembers(options);
            }
        });

        // If editing, fetch voucher data
        if (id) {
            viewvoucher(id).then((res) => {
                if (res.status === true) {
                    const data = res.data.details;
                    setFormData({
                        id: data.id,
                        voucher_type_id: data.voucher_type_id,
                        voucher_date: data.voucher_date,
                        total_amount: data.total_amount,
                        payment_mode: data.payment_mode,
                        bank_account_id: data.bank_account_id,
                        cheque_number: data.cheque_number || "",
                        cheque_date: data.cheque_date || "",
                        narration: data.narration || "",
                        status: data.status,
                        ledger_entries: data.ledger_entries.map((entry) => ({
                            account_id: entry.account_id,
                            debit_amount: entry.debit_amount,
                            credit_amount: entry.credit_amount,
                            narration: entry.narration || "",
                        })),
                    });
                }
            });
        }
    }, [id]);

    const fetchAllAccounts = () => {
        const branchId = localStorage.getItem("branch");
        listaccounts(branchId).then((res) => {
            if (res && res.status === true) {
                let dataArray = [];
                if (Array.isArray(res.data)) {
                    dataArray = res.data;
                } else if (res.data && Array.isArray(res.data.details)) {
                    dataArray = res.data.details;
                } else if (Array.isArray(res.details)) {
                    dataArray = res.details;
                } else if (Array.isArray(res)) {
                    dataArray = res;
                }


                const options = dataArray.map((acc) => ({
                    value: acc.id,
                    label: `${acc.account_code || ''} - ${acc.account_name || ''}`,
                }));
                setAccounts(options);
            }
        });
    };

    useEffect(() => {
        calculateTotal();
    }, [formData.ledger_entries]);

    const calculateTotal = () => {
        const totalDebit = formData.ledger_entries.reduce(
            (sum, entry) => sum + (parseFloat(entry.debit_amount) || 0),
            0
        );
        const totalCredit = formData.ledger_entries.reduce(
            (sum, entry) => sum + (parseFloat(entry.credit_amount) || 0),
            0
        );

        setFormData((prev) => ({
            ...prev,
            total_amount: Math.max(totalDebit, totalCredit),
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleVoucherTypeChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            voucher_type_id: selectedOption.value,
        }));
    };

    const handleBankAccountChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            bank_account_id: selectedOption ? selectedOption.value : null,
        }));
    };

    const handleLedgerEntryChange = (index, field, value) => {
        const newEntries = [...formData.ledger_entries];
        newEntries[index][field] = value;
        setFormData((prev) => ({
            ...prev,
            ledger_entries: newEntries,
        }));
    };

    const handleAccountChange = (index, selectedOption) => {
        const newEntries = [...formData.ledger_entries];
        newEntries[index].account_id = selectedOption ? selectedOption.value : "";
        setFormData((prev) => ({
            ...prev,
            ledger_entries: newEntries,
        }));
    };

    const addLedgerEntry = () => {
        setFormData((prev) => ({
            ...prev,
            ledger_entries: [
                ...prev.ledger_entries,
                { account_id: "", debit_amount: 0, credit_amount: 0, narration: "" },
            ],
        }));
    };

    const removeLedgerEntry = (index) => {
        if (formData.ledger_entries.length > 2) {
            const newEntries = formData.ledger_entries.filter((_, i) => i !== index);
            setFormData((prev) => ({
                ...prev,
                ledger_entries: newEntries,
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.voucher_type_id) {
            toast.error("Please select voucher type");
            return;
        }
        if (!formData.voucher_date) {
            toast.error("Please select voucher date");
            return;
        }

        // Validate ledger entries
        const totalDebit = formData.ledger_entries.reduce(
            (sum, entry) => sum + (parseFloat(entry.debit_amount) || 0),
            0
        );
        const totalCredit = formData.ledger_entries.reduce(
            (sum, entry) => sum + (parseFloat(entry.credit_amount) || 0),
            0
        );

        if (Math.abs(totalDebit - totalCredit) > 0.01) {
            toast.error("Total Debit and Credit must be equal!");
            return;
        }

        if (totalDebit === 0 || totalCredit === 0) {
            toast.error("Please enter valid debit and credit amounts");
            return;
        }

        setLoading(true);

        // Add branch_id from localStorage
        const submitData = {
            ...formData,
            branch_id: localStorage.getItem("branch")
        };

        createvoucher(submitData).then((res) => {
            if (res.status === true) {
                toast.success(res.message);
                navigate("/accounts/allvouchers");
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    const getTotalDebit = () => {
        return formData.ledger_entries.reduce(
            (sum, entry) => sum + (parseFloat(entry.debit_amount) || 0),
            0
        );
    };

    const getTotalCredit = () => {
        return formData.ledger_entries.reduce(
            (sum, entry) => sum + (parseFloat(entry.credit_amount) || 0),
            0
        );
    };

    return (
        <div className="container-fluid">
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Create Voucher</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a> Voucher</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Create Voucher
                    </li>
                </ol>
            </div>
            {!loading && (
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-6">
                                        <h4 className="card-title">
                                            {id ? "Edit Voucher" : "Create Voucher"}
                                        </h4>
                                    </div>
                                    <div className="col-6 text-end">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => navigate("/accounts/allvouchers")}
                                        >
                                            <i className="fa fa-arrow-left"></i> Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">
                                                Voucher Type <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                options={voucherTypes}
                                                value={voucherTypes.find(
                                                    (opt) => opt.value === formData.voucher_type_id
                                                )}
                                                onChange={handleVoucherTypeChange}
                                                placeholder="Select Type"
                                                isDisabled={id ? true : false}
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">
                                                Voucher Date <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="voucher_date"
                                                value={formData.voucher_date}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Payment Mode</label>
                                            <select
                                                className="form-control"
                                                name="payment_mode"
                                                value={formData.payment_mode}
                                                onChange={handleInputChange}
                                            >
                                                <option value="Cash">Cash</option>
                                                <option value="Bank">Bank</option>
                                                <option value="Cheque">Cheque</option>
                                                <option value="Online">Online</option>
                                            </select>
                                        </div>

                                        {formData.payment_mode !== "Cash" && (
                                            <div className="col-md-3 mb-3">
                                                <label className="form-label">Bank Account</label>
                                                <Select
                                                    options={bankAccounts}
                                                    value={bankAccounts.find(
                                                        (opt) => opt.value === formData.bank_account_id
                                                    )}
                                                    onChange={handleBankAccountChange}
                                                    placeholder="Select Bank"
                                                    isClearable
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {formData.payment_mode === "Cheque" && (
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Cheque Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="cheque_number"
                                                    value={formData.cheque_number}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Cheque Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="cheque_date"
                                                    value={formData.cheque_date}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Quick Append Member to Narration</label>
                                            <Select
                                                options={members}
                                                value={(() => {
                                                    const match = formData.narration?.match(/Member:\s*(\d+)/i) || formData.narration?.match(/(-\s*)?(\d+)$/i);
                                                    if (match) {
                                                        const extractedId = match[1] || match[2];
                                                        return members.find(m => String(m.value) === String(extractedId)) || null;
                                                    }
                                                    return null;
                                                })()}
                                                onChange={(opt) => {
                                                    if (opt) {
                                                        setFormData((prev) => {
                                                            // if member is already in there, replace the ID
                                                            if (prev.narration && /Member:\s*(\d+)/i.test(prev.narration)) {
                                                                return { ...prev, narration: prev.narration.replace(/Member:\s*(\d+)/i, `Member: ${opt.value}`) };
                                                            }

                                                            return {
                                                                ...prev,
                                                                narration: prev.narration
                                                                    ? `${prev.narration} - Member: ${opt.value}`
                                                                    : `Member: ${opt.value}`
                                                            };
                                                        });
                                                    } else {
                                                        // Handle clearing the dropdown
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            narration: prev.narration ? prev.narration.replace(/\s*-?\s*Member:\s*\d+/i, '').trim() : ''
                                                        }));
                                                    }
                                                }}
                                                placeholder="Search Member..."
                                                isClearable
                                            />
                                            <small className="text-muted">Selecting a member will automatically append their ID to the narration.</small>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Narration</label>
                                            <textarea
                                                className="form-control"
                                                name="narration"
                                                value={formData.narration}
                                                onChange={handleInputChange}
                                                rows="2"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <hr />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h5>Ledger Entries</h5>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-success"
                                                onClick={addLedgerEntry}
                                            >
                                                <i className="fa fa-plus"></i> Add Entry
                                            </button>
                                        </div>
                                    </div>

                                    <div className="table-responsive mt-3">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th width="40%">Account</th>
                                                    <th width="15%">Debit</th>
                                                    <th width="15%">Credit</th>
                                                    <th width="25%">Narration</th>
                                                    <th width="5%">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.ledger_entries.map((entry, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <Select
                                                                options={accounts}
                                                                value={accounts.find(
                                                                    (opt) => opt.value == entry.account_id
                                                                )}
                                                                onChange={(opt) =>
                                                                    handleAccountChange(index, opt)
                                                                }
                                                                placeholder="Select Account"
                                                                menuPortalTarget={document.body}
                                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={entry.debit_amount}
                                                                onChange={(e) =>
                                                                    handleLedgerEntryChange(
                                                                        index,
                                                                        "debit_amount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                step="0.01"
                                                                min="0"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={entry.credit_amount}
                                                                onChange={(e) =>
                                                                    handleLedgerEntryChange(
                                                                        index,
                                                                        "credit_amount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                step="0.01"
                                                                min="0"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={entry.narration}
                                                                onChange={(e) =>
                                                                    handleLedgerEntryChange(
                                                                        index,
                                                                        "narration",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            {formData.ledger_entries.length > 2 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => removeLedgerEntry(index)}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr className="table-secondary">
                                                    <td className="text-end">
                                                        <strong>Total</strong>
                                                    </td>
                                                    <td>
                                                        <strong>{getTotalDebit().toFixed(2)}</strong>
                                                    </td>
                                                    <td>
                                                        <strong>{getTotalCredit().toFixed(2)}</strong>
                                                    </td>
                                                    <td colSpan="2">
                                                        <strong>
                                                            Difference:{" "}
                                                            {Math.abs(
                                                                getTotalDebit() - getTotalCredit()
                                                            ).toFixed(2)}
                                                        </strong>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-12 text-end">
                                            <button
                                                type="button"
                                                className="btn btn-secondary me-2"
                                                onClick={() => navigate("/accounts/allvouchers")}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                <i className="fa fa-save"></i>{" "}
                                                {id ? "Update Voucher" : "Create Voucher"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
